import React from 'react';
import PropTypes from 'prop-types';

import Cookie from '@wetransfer/concorde-cookie';

import { connect } from 'react-redux';
import Router from '@module/router';
import I18n from '@module/i18n';

import Actions from '@app/action';
import AppConfig from '@app/config';

import Poptip from '@component/info/poptip';

import Config from './config';
import Item from './item';

let NAV_LOADED = false;
const POPTIP_ANIMATION = {
  show: {
    properties: { opacity: [1, 0] },
    options: { duration: 300, easing: [0.55, 0.86, 0.69, 0.53] },
  },
  hide: {
    properties: { opacity: 0 },
    options: { duration: 300, easing: [0.55, 0.86, 0.69, 0.53] },
  },
};

export class Navigation extends React.Component {
  constructor(props) {
    super(props);

    this.onClick = this.onClick.bind(this);
    this.showNotification = this.showNotification.bind(this);
    this.startNotification = this.startNotification.bind(this);
  }

  componentDidMount() {
    // Because otherwise the fade-in animation happens
    // every time you open/close panel.
    this.fadeInTimeout = setTimeout(() => {
      NAV_LOADED = true;
    }, 300);

    this.startNotification();
  }

  componentWillUnmount() {
    clearTimeout(this.fadeInTimeout);
    clearTimeout(this.onboardingNotificationTimeout);
    clearTimeout(this.signinNotificationTimeout);
    clearTimeout(this.tooltipTimeout);
  }

  startNotification() {
    const { route, user } = this.props;
    const notifications = Config.getNotifications();
    const showOnboarding =
      route.query.claimedDomain &&
      !Cookie.get(`wt_${notifications.onboarding.name}`);
    const showSignin =
      user.loggedIn &&
      route.type === 'transfer' &&
      !Cookie.get(`wt_${notifications.signin.name}`);

    //return in case a notification is displayed next to the logo.
    if (this.props.systemNotification) {
      return false;
    }

    if (showOnboarding) {
      this.onboardingNotificationTimeout = setTimeout(
        () => this.showNotification(notifications.onboarding.name),
        AppConfig.navigation.tooltip.showDelay
      );
    } else if (showSignin) {
      this.signinNotificationTimeout = setTimeout(
        () => this.showNotification(notifications.signin.name),
        AppConfig.navigation.tooltip.showDelay
      );
    }

    return false;
  }

  showNotification(details) {
    this.props.setPopoverNotification('notification', details);
    // Set a cookie to prevent showing the tooltip again in the coming 24h
    Cookie.set(`wt_${details}`, 1, { days: 1 });
    // Hide tooltip after a certain delay
    this.tooltipTimeout = setTimeout(
      this.props.resetPopoverNotification,
      AppConfig.navigation.tooltip.hideDelay[details]
    );
  }

  onClick(path, forcedClose = false) {
    const { resetPopoverNotification, route } = this.props;

    if (path === route.path || forcedClose === true) {
      Router.navigateTo(Router.getLastRoute('transfer', '/'));
    } else {
      Router.navigateTo(path);
    }

    resetPopoverNotification();
  }

  getNotification(menuItem) {
    const { notification } = this.props;

    if (!Object.keys(notification.popover).length) {
      return false;
    }

    if (
      !menuItem.notificationDetails ||
      menuItem.notificationDetails.length === 0
    ) {
      return false;
    }

    if (!menuItem.notificationDetails.includes(notification.popover.details)) {
      return false;
    }

    const translationKey = `notification.${notification.popover.details}`;

    return I18n.t(translationKey) || notification.panel.details;
  }

  render() {
    const { route, layout } = this.props;
    const currentRouter = Router.currentRouter;

    let items = Config.getItems();
    const menuItems = [];
    const classNames = ['nav'];
    let nav = null;

    // Is the panel open or not?
    if (route.type !== 'transfer') {
      classNames.push('nav--with-panel');
    }

    // To prevent fade-in from re-appearing.
    if (NAV_LOADED) {
      classNames.push('nav--loaded');
    }

    if (layout.hidden === true) {
      classNames.push('nav--html5-fullscreen');
    }

    // Render a single back button item in the nav
    if (currentRouter) {
      const lastPathOptions = currentRouter.lastPathOptions;
      if (lastPathOptions.backTo) {
        items = Config.getBackButtonItem(
          lastPathOptions.backButtonText,
          lastPathOptions.backTo
        );
      }
    }

    // Render all of our items
    for (const menuItem of items) {
      const notification = this.props.systemNotification
        ? null
        : this.getNotification(menuItem);

      const item = (
        <Item key={menuItem.name} onClick={this.onClick} {...menuItem} />
      );
      if (notification) {
        menuItems.push(
          <Poptip
            className="nav__item-tooltip"
            effects={POPTIP_ANIMATION}
            offset={12}
            autoHide={true}
            visible={true}
            trigger="manual"
            anchor="bottom-left"
            content={<span>{notification}</span>}
            key={menuItem.name}
          >
            {item}
          </Poptip>
        );
      } else {
        menuItems.push(item);
      }
    }
    nav = <ul className="nav__items">{menuItems}</ul>;

    return <nav className={classNames.join(' ')}>{nav}</nav>;
  }
}

Navigation.propTypes = {
  layout: PropTypes.object.isRequired,
  notification: PropTypes.object.isRequired,
  resetPopoverNotification: PropTypes.func.isRequired,
  route: PropTypes.object.isRequired,
  setPopoverNotification: PropTypes.func.isRequired,
  systemNotification: PropTypes.string,
  user: PropTypes.object.isRequired,
};

const mapStateToProps = ({ layout, notification, route, user }) => ({
  layout,
  notification,
  route,
  user,
});
export default connect(
  mapStateToProps,
  Actions.Notification
)(Navigation);
